import { Injectable, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class DjingoService {
  constructor(private router: Router) {}

  open(): void {
    this.checkAndOpenDivDjingo();
  }

  async checkAndOpenDivDjingo(): Promise<void> {
    // tempo chargement du script - djingo variables are loaded
    const windowAP: any = window;
    let loopDelay = 0;
    while (windowAP.openDjingoChatWindow === undefined && loopDelay < 20) {
      await this.delay(100);
      loopDelay++;
    }
    windowAP.openDjingoChatWindow();
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  updateQueryParamsInUrl(route: ActivatedRoute, queryParamsToUpdate: any): void {
    this.router.navigate(['.'], {
      relativeTo: route,
      queryParams: queryParamsToUpdate,
      queryParamsHandling: 'merge',
    });
  }

  disableDjingo = (renderer: Renderer2): void => {
    this.deleteVignette(renderer);
    // disable mode vignette / historique
    const windowAP: any = window;
    windowAP.djingoChatConfig = {
      vignette: {
        display: false,
      },
      integration: false,
    };
  };

  djingoChatConfig(
    callerId: string,
    rubrique: string,
    integration: boolean,
    displayVignette: boolean,
    rightVignette?: string,
    bottomVignette?: string
  ): void {
    // si le param integration = true -> historique de la conversation est conserve et ouverture de la div (pas besoin de faire un open)
    // si le param integration = false -> pas de conservation de l'historique et necessite de faire un appel a open pour ouvrir la div avec en param l'intention si besoin
    const windowAP: any = window;
    windowAP.djingoChatConfig = {
      vignette: {
        version: 'default',
        display: displayVignette,
        bottom: bottomVignette ? bottomVignette : '',
        right: rightVignette ? rightVignette : '',
        waitOpen: 1,
        waitClose: 5,
        text: 'Poursuivons notre échange',
      },
      rubrique: rubrique ? rubrique : '',
      callerId,
      integration,
      usage: '',
      contrat: '',
      callBack: {
        onClick: () => {},
        onRender: () => {},
        onMouseEnter: () => {},
        onMouseLeave: () => {},
      },
    };
  }

  loadDjingoScript(renderer: Renderer2, srcUrl: string): void {
    const head: Element = renderer.selectRootElement('head', true);
    const djingoScript = renderer.createElement('script');
    djingoScript.type = 'text/javascript';
    djingoScript.src = srcUrl;
    djingoScript.async = false;
    renderer.appendChild(head, djingoScript);
  }

  private deleteVignette(renderer: Renderer2): void {
    const vignette = document.getElementById('djingoVignette');
    const body: Element = renderer.selectRootElement('body', true);
    if (vignette) {
      renderer.removeChild(body, vignette);
    }
  }

  private delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }
}
